import { withoutSourceSignatures } from "./handoutContent";
const uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const handoutSourceLabel = (value) => {
  const question = value || {};
  const source = withoutSourceSignatures(question.question_source ?? question.math_bank?.question_source ?? "");
  const identity = [question.math_bank?.id, question.question_uuid, question.id]
    .find((value) => uuid.test(String(value || "")));
  return identity ? `${source}\n${String(identity).toLowerCase()}` : source;
};

// Match answer_boxes.box_height's source paragraph estimate and its fixed host
// line. Hidden source glyphs still reserve this space in the exported Word.
export const handoutResponseMinHeight = (source, widthPx, hasAnswer, reserveHiddenSource = true) => {
  if (!(widthPx > 0)) return undefined;
  // Plain Word handouts anchor hidden sources behind the text without reserving
  // their full shape height. Only a visible answer needs a response row.
  if (!reserveHiddenSource) return hasAnswer ? 36 : 0;
  const halfWidthPt = widthPx * 72 / 96 / 2;
  const units = Array.from(String(source).replace(/\n/g, ""))
    .reduce((sum, character) => sum + (character.codePointAt(0) > 255 ? 1 : .6), 0);
  const lines = Math.max(1, Math.ceil(units * 12 / Math.max(halfWidthPt - 24, 60))) + (String(source).match(/\n/g) || []).length;
  const sourceHeight = source ? Math.max(30, lines * 20 + 12) : 0;
  return sourceHeight || hasAnswer ? Math.max(sourceHeight, hasAnswer ? 32 : 0) + 4 : 0;
};
